'use client';

import { ComponentPropsWithoutRef } from 'react';
import { useIsInertBecauseOfMenu } from '../pageHeader/mainMenu/MainMenu.client';
import { classes } from '@/uiPrimitives/base/classes.helpers';

export const PageFooterClient = ({
	className,
	...props
}: ComponentPropsWithoutRef<'footer'>) => {
	const inert = useIsInertBecauseOfMenu();

	return <footer {...props} inert={inert} className={classes(className)} />;
};
